var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolly-content-image"},_vm._l((_vm.attributes.p.length),function(index){return _c('img',{key:index,style:(_vm.getImageStyle(index)),attrs:{"src":_vm.getSource(index)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }